<template>
  <div class="profile-detail">
    <template v-if="!loading && !errors.length && applicant !== null">
      <basic-info :profile="basicInfo" v-on:basicLoaded="basicL()"/>
      <academic-info :academic="academicInfo" v-on:academicLoaded="academicL()"/>
      <employment-info :history="employmentHistory" v-on:employmentLoaded="employmentL()"/>
    </template>
    <Loader v-show="loading"/>
  </div>
</template>

<script>
import AcademicInfo from '@/components/dashboard/applicants/profile/DAcademicInfo.vue';
import BasicInfo from '@/components/dashboard/applicants/profile/DBasicInfo.vue';
import EmploymentInfo from '@/components/dashboard/applicants/profile/DEmploymentInfo.vue';
import Loader from '@/components/utils/Loader.vue';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'PrintProfile',
  components: {
    Loader, EmploymentInfo, AcademicInfo, BasicInfo,
  },
  data() {
    return {
      applicant: null,
      errors: [],
      loading: false,
      basicLoaded: false,
      academicLoaded: false,
      employmentLoaded: false,
    };
  },
  watch: {
    basicLoaded() {
      this.print();
    },
    academicLoaded() {
      this.print();
    },
    employmentLoaded() {
      this.print();
    },
  },
  mounted() {
    this.loadProfile();
  },
  computed: {
    basicInfo() {
      if (this.applicant !== null) {
        const {
          name, gender, birthDate, email, phone, residence, employment, furigana,
        } = this.applicant;
        return {
          name,
          gender,
          birthDate,
          email,
          phone,
          residence,
          position: employment.position,
          furigana: furigana || 'N/A',
        };
      }
      return null;
    },
    academicInfo() {
      if (this.applicant !== null) return this.applicant.education;
      return null;
    },
    employmentHistory() {
      if (this.applicant !== null) return this.applicant.employment;
      return null;
    },
  },
  methods: {
    basicL() {
      this.basicLoaded = true;
    },
    employmentL() {
      this.employmentLoaded = true;
    },
    academicL() {
      this.academicLoaded = true;
    },
    loadProfile() {
      this.loading = true;
      ApiService.get(Api.endpoints.APPLICANT_PROFILE(this.$route.params.id))
        .then(({ data }) => {
          this.applicant = data.data.applicant;
          this.print();
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.loading = false;
        });
    },
    print() {
      if (this.basicLoaded && this.academicLoaded && this.employmentLoaded) {
        const x = document.getElementsByTagName('header');
        x[0].style.display = 'none';
        this.$nextTick(() => {
          document.title = '';
          window.print();
        });
        window.onafterprint = () => {
          window.close();
        };
      }
    },
  },
};
</script>
<style>
@page {
  size: auto;
  margin: 0mm;
}

@media print {
  header {
    display: none !important;
  }
  .profile-desc ul {
    padding-top: 8px;
  }
}
</style>
